export const CyMultiSelectableList = {
  CheckboxToggleAll: "CheckboxToggleAll",
} as const;
